import { call, put, takeLatest } from "redux-saga/effects";
import {
  getAllDocumentsStart,
  getAllDocumentsSuccess,
  getAllDocumentsFailure,
  //updateW4FormDocumentsStart, // omkar commented this vite issue
  addW4FormDocumentsStart,
  //getAllW4FormDocumentsStart, // omkar commented this vite issue
  getAllTaxFormDocumentsStart,
  getAllTaxFormDocumentsSuccess,
  getplacementDocumentsStart,
} from "./documentSlice";
import {
  addW4FormDocuments,
  fetchAllDocuments,
  fetchAllTaxFormDocuments,
} from "./documentApi";
import { totalCountSuccess } from "../totalCount/totalCountSlice";
import { fetchAllPlacements } from "../placements/placementsApi";

function* fetchAllDocumentsSaga(action) {
  try {
    const documents = yield call(fetchAllDocuments, action.payload);
    console.log("documents", documents);
    if (documents.success) {
      // yield put(
      //   totalCountSuccess({
      //     count: documents.totalCount.data,
      //     meta: { collection: action.payload.coll },
      //   })
      // );
      yield put(getAllDocumentsSuccess(documents.data.data));
    }
    // yield put(getAllDocumentsSuccess(documents.data));
  } catch (error) {
    yield put(getAllDocumentsFailure(error.message));

    // yield put(
    //       totalCountSuccess({
    //         count: 0,
    //         meta: { collection: action.payload.coll },
    //       })
    //     );
    yield put(getAllDocumentsSuccess([]));
  }
}

function* addW4FormDocumentsSaga(action) {
  try {
    const { onSuccess, ...payload } = action.payload;
    const documents = yield call(addW4FormDocuments, payload);
    console.log("documents", documents);

    if (documents?.success && typeof onSuccess === "function") {
      yield call(onSuccess, documents); // ✅ proper way to call a function inside a saga
    }
  } catch (error) {
    console.error("Error in addW4FormDocumentsSaga:", error);
  }
}
function* fetchAllTaxDocumentsSaga(action) {
  try {
    const { tab, ret, ...payload } = action.payload;
    const documents = yield call(fetchAllTaxFormDocuments, payload);
    if (documents?.success) {
      yield put(getAllTaxFormDocumentsSuccess({ [ret]: documents.data.data }));
    } else {
      yield put(getAllTaxFormDocumentsSuccess({ [ret]: [] }));
    }
  } catch (error) {
    console.error("Error in addW4FormDocumentsSaga:", error);
  }
}
function* getplacementDocumentsSaga(action) {
  try {
    const { tab, ret, ...payload } = action.payload;
    const documents = yield call(fetchAllPlacements, payload);
    if (documents?.success) {
      yield put(getAllTaxFormDocumentsSuccess({ [ret]: documents.data.data }));
    } else {
      yield put(getAllTaxFormDocumentsSuccess({ [ret]: [] }));
    }
  } catch (error) {
    console.error("Error in addW4FormDocumentsSaga:", error);
  }
}

export function* watchFetchAllDocuments() {
  yield takeLatest(getAllDocumentsStart.type, fetchAllDocumentsSaga);
  yield takeLatest(getAllTaxFormDocumentsStart.type, fetchAllTaxDocumentsSaga);
  yield takeLatest(addW4FormDocumentsStart.type, addW4FormDocumentsSaga);
  yield takeLatest(getplacementDocumentsStart.type, getplacementDocumentsSaga);
}
